<template>
	<div class="NavBer">
		<div class="">
			<div style="display: flex;justify-content: space-between;">
				<ul class="flex nav arouter-linkgn-center justify-between texts">
					<router-link to="/" class="logo">
						<img src="../../assets/images/logo.png" />
					</router-link>

					<router-link to="/">首页</router-link>
					<router-link to="/product">产品中心</router-link>
					<!-- <router-link to="/cooperate">咨询合作</router-link> -->
					<router-link to="/overview">关于我们</router-link>
					<!-- <router-link to="/charge">收费模式</router-link> -->
					<router-link to="/about">联系我们</router-link>
				</ul>
				<!-- <div style="text-align: right; margin-right: 100px; margin-top: 20px;">
					<span style="margin-right: 20px;" @click="openDialog(1)" v-if="nameType == ''">登录</span>
					<span @click="openDialog(2)" v-if="nameType == ''">注册</span>

					<span v-if="nameType != ''"><span class="el-icon-user-solid"></span> {{ nameType }}<span @click="exitLogon" style="color: #666666;cursor: pointer; font-size: 12px;"> 退出登录</span></span>
				</div> -->
			</div>
		</div>
		<el-dialog title="登录" :visible.sync="dialogFormVisible" append-to-body width="30%">
			<el-form
				:model="ruleForm"
				:rules="rules"
				ref="ruleForm"
				label-width="100px"
				class="demo-ruleForm"
				size="mini"
			>
				<el-form-item label="手机号" prop="phone">
					<el-input style="width: 200px;" v-model="ruleForm.phone"></el-input>
				</el-form-item>
				<el-form-item label="邮箱" prop="email" v-if="dialogType == 2">
					<el-input style="width: 200px;" v-model="ruleForm.email"></el-input>
				</el-form-item>
				<el-form-item label="密码" prop="password">
					<el-input style="width: 200px;" type="password" v-model="ruleForm.password"></el-input>
				</el-form-item>
				<el-form-item label="确认密码" prop="pyPassword" v-if="dialogType == 2">
					<el-input style="width: 200px;" type="password" v-model="ruleForm.pyPassword"></el-input>
				</el-form-item>

				<el-form-item>
					<el-button type="primary" @click="submitForm('ruleForm')">{{
						dialogType == 2 ? "立即创建" : "登录"
					}}</el-button>
					<el-button @click="resetForm('ruleForm')">清空</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>
	</div>
</template>

<script>
export default {
	name: "NavBar",
	data() {
		var checkPhone = (rule, value, callback) => {
			// 手机号验证
			if (!value) {
				return callback(new Error("手机号不能为空"));
			} else {
				const reg = /^1[3456789]\d{9}$/;
				if (reg.test(value)) {
					callback();
				} else {
					return callback(new Error("请输入正确的手机号"));
				}
			}
		};

		var isEmail = (rule, value, callback) => {
			if (!value) {
				callback();
			} else {
				const reg = /^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$/;
				const email = reg.test(value);
				if (!email) {
					callback(new Error("邮箱格式如:admin@163.com"));
				} else {
					callback();
				}
			}
		};

		return {
			dialogFormVisible: false,
			ruleForm: {
				phone: "",
				email: "",
				password: "",
				pyPassword: ""
			},
			rules: {
				phone: [
					{ required: true, message: "请输入正确的手机号", trigger: "blur" },
					{ validator: checkPhone, trigger: "blur" },
				],
				email: [
					{ required: true, message: "请输入邮箱", trigger: "blur" },
					{ validator: isEmail, trigger: "blur" },
				],
				password: [{ required: true, message: "请输入密码", trigger: "blur" }],
				pyPassword: [{ required: true, message: "请输入确认密码", trigger: "blur" }],
			},
			dialogType: 1,
			nameType: "",
		};
	},
	mounted() {
		this.nameType = localStorage.getItem("nameType") || '';
        console.log(this.nameType)
	},
	methods: {
		openDialog(type) {
           this.ruleForm = {
				phone: "",
				email: "",
				password: "",
				pyPassword: ""
			}
			this.dialogFormVisible = true;
			this.dialogType = type;
		},

		submitForm(formName) {
			this.$refs[formName].validate((valid) => {
				if (valid) {
					this.nameType = this.ruleForm.phone;
					this.dialogFormVisible = false;
					//手机号存到本地
					localStorage.setItem("nameType", this.ruleForm.phone);
				} else {
					console.log("error submit!!");
					return false;
				}
			});
		},
		resetForm(formName) {
			this.$refs[formName].resetFields();
		},
        exitLogon() {
            this.nameType = '';
            localStorage.removeItem("nameType");
        }
	},
};
</script>

<style scoped>
.NavBer {
	position: fixed;
	background-image: linear-gradient(to right, #00ea92, #0ba57a);
	width: 100%;
	top: 0;
	z-index: 1000;
	border-bottom: 0.5px solid #ccc;
	z-index: 99999;
}
.logo {
	width: 400px;
	height: 90px;
	background-color: #ffffff;
	text-align: center;
}
.logo img {
	width: 80px;
	height: 70px;
	/* text-align: center; */
	vertical-align: middle;
}
.texts {
	font-size: 18px;
	font-weight: 400;
	color: #000;
	/* vertical-align:middle; */
}
.texts a:hover {
	color: #f2af46;
}
.router-link-exact-active {
	color: #f2af46;
}

.nav {
	width: 1000px;
	height: 90px;
	line-height: 90px;
}
</style>
